import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "price"]
  
  updatePrice(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const price = selectedOption.value
    const size = selectedOption.dataset.size
    
    
    // Mettre à jour l'affichage du prix
    this.priceTarget.textContent = this.formatCurrency(price)
    
    // Mettre à jour le data-attribute du bouton "Ajouter au panier"
    const addButton = document.querySelector('[data-action*="addToCart"]')
    if (addButton) {
      addButton.dataset.parfumPrice = price
      addButton.dataset.parfumSize = size
    }
    
    // FIXÉ: Mettre à jour le bouton "Acheter maintenant" AUSSI
    const buyButton = document.querySelector('[data-action*="buyNow"]')
    if (buyButton) {
      buyButton.dataset.parfumPrice = price
      buyButton.dataset.parfumSize = size
      // IMPORTANT: Mettre à jour aussi la taille dans les paramètres
      const currentUrl = buyButton.href || ''
      buyButton.dataset.parfumSize = size
    }
  }
  
  formatCurrency(amount) {
    return new Intl.NumberFormat('fr-TN', { 
      style: 'currency', 
      currency: 'TND',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)
  }
}